import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,} from "@angular/core";
import {ConfirmationService} from "primeng/api";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {EventInterface, Person} from "../../../../../core/shared/scheduler/interfaces/scheduler.interface";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";

// NOT_IN_USE
@Component({
    selector: "as-calendar-component",
    templateUrl: "./as-calendar.component.html",
    standalone: false
})
export class AsCalendarComponent extends ObjectBaseComponent
    implements OnInit, OnChanges {

    initialized: boolean;

    @Input() module: string;
    @Input() refreshTrigger: number | string | boolean;
    @Input() roleBasedFilter: FilterCriteria[];

    persons: Person[] = [];


    events: EventInterface[];

    @Output() onDataLoaded = new EventEmitter<void>();

    filterCriteria: FilterCriteria[];

    constructor(
        protected coreService: MvsCoreService,
        protected confirmationService: ConfirmationService,
        protected messageService: MvsMessageService,
        protected observerService: ObserverService) {

        super(coreService, messageService, confirmationService, observerService);

    }

    ngOnInit() {

        if (this.params) {
            const test = JSON.parse(this.params.module);


            const rawEvents = test['events'];
            this.events = rawEvents.map(this.parseEvent);


            this.persons = test['person'];
        }

        this.refresh();
        this.initialized = true;
    }


    /**
     * On Object Change.
     */
    refresh() {

    }

    parseEvent(event: any): EventInterface {
        return {
            ...event,
            preEventDto: {
                start: new Date(event.preEventDto.start),
                end: new Date(event.preEventDto.end)
            },
            mainEventDto: {
                start: new Date(event.mainEventDto.start),
                end: new Date(event.mainEventDto.end)
            },
            postEventDto: {
                start: new Date(event.postEventDto.start),
                end: new Date(event.postEventDto.end)
            }
        };
    }


    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (!this.initialized) {
            return;
        }
        this.refresh();
    }

}

